import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IDocumentTemplateBaseItem } from '@fi-app/template/base-item.model';

@Injectable()
export class FiDocumentTemplateOptionsService {
    public selectedItem: IDocumentTemplateBaseItem;
    onRemoveFileFromSelectedItem$: Subject<HTMLElement> = new Subject<HTMLElement>();
}
